import { apiWithAuth } from "../authApi";
import { Rewards, WithdrawDepositRewards } from "@/modules/user/types/wallet";

export const getRewards = async (): Promise<Rewards | undefined> => {
  try {
    const response = await apiWithAuth.get("/user/rewards");

    const answer = response.data as Rewards;

    return answer;
  } catch (error) {
    return undefined;
  }
};

export const getWithdrawDepositRewards = async (
  withdrawalType: "ton" | "token" | "reinvest" | undefined = undefined,
  tokenAmount: number | undefined = undefined,
  includeCreatedBefore: boolean | undefined = undefined,
  network: "TON" | "EVM" | undefined = undefined,
  chainId: number | undefined = undefined
): Promise<WithdrawDepositRewards | undefined> => {
  try {
    const params = new URLSearchParams();

    if (tokenAmount !== undefined)
      params.append("tokenAmount", tokenAmount.toString());
    if (includeCreatedBefore !== undefined)
      params.append("includeCreatedBefore", includeCreatedBefore.toString());
    if (withdrawalType) params.append("withdrawalType", withdrawalType);
    if (network) params.append("network", network);
    if (chainId) params.append("chainId", chainId.toString());

    const response = await apiWithAuth.get(
      `/user/withdraw/deposit/rewards?${params.toString()}`
    );

    const data = response.data as WithdrawDepositRewards;

    return data;
  } catch (error) {
    return undefined;
  }
};

export const postWithdrawDepositRewards = async (
  tokenAmount: number,
  withdrawalType: "ton" | "token",
  network: "TON" | "EVM",
  chainId: number
): Promise<unknown | undefined> => {
  try {
    const response = await apiWithAuth.post("/user/withdraw/deposit/rewards", {
      tokenAmount,
      withdrawalType,
      network,
      chainId: chainId.toString(),
    });

    const data = response.data;

    return data;
  } catch (error) {
    return undefined;
  }
};
